module.exports = __webpack_public_path__ + "static/media/volunteer.f6ac0753.svg";